let session_practiceInfo = {};
let session_selectedSpeciality = { id: 32, name: "Primary Care" };
let session_account_names = {};
let session_location_names = {};
let session_practice_insurances = [];
let session_access_token = "";
let session_refresh_token = "";
let session_feature_configs = {};
let session_caregap_additional = {};
let session_message_templates = [];
let session_pending_qm = {};

export const setPracticeInfo = (session_practiceInfo_data) => {
  session_practiceInfo = session_practiceInfo_data;
};

export const getPracticeInfo = () => {
  return session_practiceInfo;
};


export const setSelectedSpeciality = (session_selectedSpeciality_data) => {
  session_selectedSpeciality = session_selectedSpeciality_data;
};

export const getSelectedSpeciality = () => {
  return session_selectedSpeciality;
};


export const setAccountNames = (session_account_names_data) => {
  session_account_names = session_account_names_data;
};

export const getAccountNames = () => {
  return session_account_names;
};


export const setLocationNames = (session_location_names_data) => {
  session_location_names = session_location_names_data;
};

export const getLocationNames = () => {
  return session_location_names;
};

export const setInsurancesList = (session_practice_insurances_data) => {
  session_practice_insurances = session_practice_insurances_data;
};

export const getInsurancesList = () => {
  return session_practice_insurances;
};


export const setAccessToken = (session_access_token_data) => {
  session_access_token = session_access_token_data;
};

export const getAccessToken = () => {
  return session_access_token;
};

export const setRefreshToken = (session_refresh_token_data) => {
  session_refresh_token = session_refresh_token_data;
};

export const getRefreshToken = () => {
  return session_refresh_token;
};

export const setFeatureConfigs = (session_feature_configs_data) => {
  session_feature_configs = session_feature_configs_data;
};

export const getFeatureConfigs = () => {
  return session_feature_configs;
};

export const setCaregapAdditionalData = (session_caregap_additional_data) => {
  session_caregap_additional = session_caregap_additional_data;
  
};

export const getCaregapAdditionalData = () => {
  return session_caregap_additional;
};

export const setMessageTemplatesData = (session_message_templates_data) => {
  session_message_templates = session_message_templates_data;
};

export const getMessageTemplatesData = () => {
  return session_message_templates;
};

export const setPendingQmData = (session_pending_qm_data) => {
  session_pending_qm = session_pending_qm_data;
};

export const getPendingQmData = () => {
  return session_pending_qm;
};
